import { medialUrl } from "../../../EndPoints";

import OuterImg from "../../../assets/images/sister-concern/bd-knit-design/outer-img.png";
import PoleStartKnittingImg from "../../../assets/images/sister-concern/pole-star-fashion/pole-star-knitting.png";
import PrintingImg from "../../../assets/images/sister-concern/bd-knit-design/printing.png";

import SferaLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/sfera.png";
import VertbaudetLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/vertbaudet.png";
import AldiLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/aldi.png";
import LaHalleLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/la-halle.png";
import RegattaLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/regatta.png";
import MangoLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/mango.png";
import NewLookLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/new-look.png";
import OstinLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/ostin.png";
import IdentityLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/id.png";
import GemoLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/gemo.png";
import ArtsanaLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/artsana.png";
import SportsGroupLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/sports-group-denmark.png";
import ChiccoLogo from "../../../assets/images/sister-concern/pole-star-fashion/logos/chicco.png";

export const statPoleStarFashion = [
  {
    number: 10,
    text: "Lines",
    icon: `${medialUrl}/img/icons/Apartment.jpg`,
  },
];

export const productLineTitle = "Our Division";
export const productLinePoleStarFashionContent = [
  [
    {
      division: "Woven Division",
      title: "Product Line",
      text: "Men’s, Ladies & Children Wear (Basic Shirt & Classical Shirt) Tops & Bottom.",
    },
    {
      division: "Woven Division",
      title: "Using Yarn/ Fabrics type",
      text: "100% Cotton, 100% Cotton Y/D, 65 % polyesters 35 % Cotton, 100 % Cotton Y/D Twill Filament, Input Fabric Like Viscose etc.",
    },
  ],
  [
    {
      division: "Knit Division",
      title: "Product Line of Knit Item",
      text: "Ladies Long Sleeve T-Shirt, Ladies Tank Top, Ladies S/S T-Shirt, Ladies Frog, Polo Shirt, Bottom, Night Dress, Kids Item, Yoga, viscose etc.",
    },
    {
      division: "Knit Division",
      title: "Using Yarn/ Fabrics type",
      text: "100% Cotton, 100% Cotton Y/D, 65 % polyesters 35 % Cotton, 100 % Cotton Y/D Twill Filament, Input Fabric Like Viscose etc.",
    },
  ],
];

export const associateBusinessPoleStarFashion = {
  title: "Sister Concerns",
  outerImage: OuterImg,
  arr: [
    {
      img: PrintingImg,
      innerTitle: "Pole Star Printing & Embroidery",
    },
    {
      img: PoleStartKnittingImg,
      innerTitle: "Pole Star Knitting Ltd.",
    },
  ],
};

export const OurCustomersPoleStarFashionImages = [
  [
    VertbaudetLogo,
    SferaLogo,
    AldiLogo,
    LaHalleLogo,
    RegattaLogo,
    MangoLogo,
    NewLookLogo,
  ],
  [OstinLogo, IdentityLogo, MangoLogo, ArtsanaLogo, NewLookLogo, GemoLogo],
  [
    SportsGroupLogo,
    ChiccoLogo,
    AldiLogo,
    IdentityLogo,
    OstinLogo,
    VertbaudetLogo,
    RegattaLogo,
  ],
];
